<template>
    <div class="children-childtrackingsystem">
        <div v-if="!isContent">
            <div class="row table-row border-bottom-0 pt-2 pb-2">
                <div class="col-12"><br><b>DEFINITIEVE OBSERVATIEFORMULIEREN</b></div>
            </div>
            <div v-if="childForms.length > 0" class="row table-border-first">
                <div class="col-7">Observatieformulier titel</div>
                <div class="col-3"><span v-if="permitShare">Delen met verzorgers</span></div>
                <div class="col-2"></div>
            </div>
            <div v-else class="row table-row border-bottom-0 pt-2 pb-2">
                <div class="col-12">Kind heeft nog geen definitieve  observatieformulieren.</div>
            </div>
            <div class="row table-row border-bottom-0 pb-2" v-bind:key="key" v-for="(form, key) in childForms">
                <div class="col-7"><b>{{ form.title }}</b> <br> van {{ formatDate(form.date) }}</div>
                <div class="col-3">
                    <input type="checkbox"
                           v-if="permitShare"
                           name="delen"
                           value="delen"
                           :checked="form.share"
                           v-on:input="shareForm($event, form.idChildForm)"/><span v-if="permitShare"> Laatste antwoorden</span> <br>
                    <input type="checkbox"
                           v-if="permitShare"
                           name="delenKindTraject"
                           value="delenKindTraject"
                           :checked="form.shareChildTraject"
                           v-on:input="shareForm($event, form.idChildForm)"/><span v-if="permitShare"> Kind traject</span>
                </div>
                <div class="col-2 text-end">
                    <span class="me-3" @click="printChildForm(form.idChildForm, form.idResult)">
                        <icon name="file-add"></icon>
                    </span>
                    <router-link :to="'/childtrackingsystem/editchildform/' + form.idResult + '/' + form.idChildForm" style="color:#666;">
                        <span title="Bekijk">
                            <icon name="look-into"></icon>
                        </span>
                    </router-link>
                </div>
            </div>
            <div v-if="forms.length > 0 || hasGeneralForms" class="row table-row border-bottom-0">
                <div class="col-12" style="background-color: #666;height:3px;"></div>
            </div>
            <div v-if="forms.length > 0 || hasGeneralForms" class="row table-row border-bottom-0">
                <div v-if="forms.length > 0" class="col-6"><b>ALGEMENE FORMULIEREN</b></div>
                <div v-if="forms.length > 0"  class="col-5 text-end">
                    <select class="form-select pt-0" style="width:300px; height: 30px; color: #666;" name="selectedForm" v-model="selectedForm">
                        <option value="0">Kies een formulier</option>
                        <option v-bind:key="kform" v-for="(form, kform) in forms"
                                :value="form.id_kindvolgsysteem_observatieformulier">{{ form.titel }}</option>
                    </select>
                </div>
                <div v-if="forms.length > 0"  class="col-1 text-end">
                    <span @click="makeForm()">
                        <icon name="file-add"></icon>
                    </span>
                </div>
            </div>
            <div class="row table-row border-bottom-0 pt-2 pb-2" v-if="!hasGeneralForms">
                <div class="col-12">Kind heeft nog geen algemene formulieren.</div>
            </div>
            <div v-if="hasGeneralForms">
                <div class="row table-border-first">
                    <div class="col-7">Formulier titel</div>
                    <div class="col-3"><span v-if="permitShare">Delen</span></div>
                    <div class="col-2"></div>
                </div>
                <div class="row table-row border-bottom-0 pt-2 pb-2"
                     v-bind:key="kg" v-for="(generalForm, kg) in generalForms">
                    <div class="col-7"> <b>{{ generalForm.title }}</b> <br> bijgewerkt op {{ generalForm.updatedAt }}</div>
                    <div class="col-3"><input v-if="permitShare"
                                              type="checkbox"
                                              name="delen"
                                              value="delen"
                                              :checked="generalForm.share"
                                              v-on:input="shareForm($event, generalForm.idGeneralForm)"/> <span v-if="permitShare"> Delen met verzorgers<br></span>
                        <!--DIT is voor later input v-if="permitShare"
                                                  type="checkbox"
                                                  name="delenSchool"
                                                  value="delenSchool"
                                                  :checked="generalForm.shareSchool"
                               v-on:input="shareForm($event, generalForm.idGeneralForm)"/> <span v-if="permitShare">Delen met school</span --->
                    </div>
                    <div class="col-2 text-end">
                        <span class="me-3" @click="printForm(selectedChild.id, generalForm.idForm, generalForm.idGeneralForm)">
                            <icon name="file-pdf"></icon>
                        </span>
                        <router-link
                            :to="'/childtrackingsystem/generalForm/' + selectedChild.id + '/' + generalForm.idForm + '/' + generalForm.idGeneralForm"
                            style="color:#666;">
                            <icon name="look-into"></icon>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="row table-row border-bottom-0">
                <div class="col-12" style="background-color: #666;height:3px;"></div>
            </div>
            <div class="row table-row border-bottom-0">
                <div class="col-11"><b>EXTERNE DOCUMENTEN</b></div>
                <div class="col-1 text-end">
                    <div
                        data-bs-toggle="modal"
                        data-bs-target="#modalUploadFiles"
                    >
                        <icon name="upload"></icon>
                    </div>
                </div>
                <div
                    class="modal"
                    id="modalUploadFiles"
                    tabindex="-1"
                >
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Bestanden uploaden</h5>
                                <button
                                    class="btn-close"
                                    type="button"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div class="modal-body">
                                <div class="input-group">
                                    <input
                                        class="form-control"
                                        type="file"
                                        ref="file"
                                        multiple
                                    >
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button
                                    class="btn btn-info"
                                    type="button"
                                    name="upload"
                                    value="upload"
                                    @click="uploadSave()"
                                >Opslaan</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row table-border-first">
                <div class="col-7">Document titel</div>
                <div class="col-3"><span v-if="permitShare">Delen</span></div>
                <div class="col-2"></div>
            </div>
            <div class="row table-row border-bottom-0 pt-2 pb-2" v-bind:key="kd" v-for="(doc, kd) in docs">
                <div class="col-7">{{ doc.filename }}</div>
                <div class="col-3">
                    <input v-if="permitShare"
                           type="checkbox"
                           name="delen"
                           value="delen"
                           :checked="doc.share"
                           v-on:input="shareDocument($event, doc.id)"/> Delen met verzorgers
                </div>
                <div class="col-2 text-end">
                    <span
                        class="me-3"
                        title="Download document"
                        @click="downloadDocument(doc.id)"
                    >
                        <icon name="file-pdf"></icon>
                    </span>
                    <span
                        title="Wis"
                        @click="deleteDocument(doc.id, doc.filename)"
                    >
                        <icon name="delete"></icon>
                    </span>
                </div>
            </div>
        </div>
        <div class="row table-row border-bottom-0">
            <div class="col-12" style="background-color: #666;height:3px;"></div>
        </div>
        <div v-if="isContent" class="row">
            <div class="col-md-12">
                <childtrackingsystem-observationform :idResult="resultId" :idChild = "childId" :idList="listId" :idForm="formId"></childtrackingsystem-observationform>
            </div>
        </div>
        <div class="row bg-white"><br><br><div class="modalLoader" v-if="isLoading">
            <img src="../../assets/img/loading.gif" alt="loading..." style="width: 80px; height: 80px;"/>
        </div>
        </div>
    </div>
</template>

<script>
import ChildtrackingsystemObservationform from "@/views/childtrackingsystem/ObservationForm";
import icon from "@/components/Icon.vue";
import { downloadBase64File } from '@/helpers/DownloadFile.js'

export default {
    name: 'children-childtrackingsystem',
    props: ['id'],
    components: {icon, ChildtrackingsystemObservationform},
    data () {
        return {
            isContent: false,
            childId: null,
            listId: null,
            formId: null,
            resultId: null,
            childForms: [],
            docs: [],
            isLoading: false,
            files: [],
            dToken: null,
            sToken: null,
            idDoc: null,
            permitShare: false,
            forms: [],
            generalForms: [],
            hasGeneralForms: false,
            selectedForm: 0
        }
    },
    computed: {
        deviceToken() {
            return this.$store.getters.deviceToken
        },
        session() {
            return this.$store.getters.session
        },
    },
    created() {
        window.novict = {
            device: {
                device_token: this.deviceToken
            },
            session: {
                session_token: this.session.session_token
            }
        }
        this.getChildTrackingSystem()
    },
    methods: {
        getChildTrackingSystem () {
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            this.$request.post( '/ChildTrackingSystem/getChildForms', {
                idChild: this.selectedChild.id
            }).then((response) => {
                this.$store.commit('REMOVE_ACTIVE_REQUEST')
                if (response) {
                    this.childForms = response.childForms
                    this.docs = response.docs
                    this.forms = response.forms
                    this.generalForms = response.generalForms
                    if (this.generalForms.length > 0) {
                        this.hasGeneralForms = true
                    }
                    this.permitShare = response.isAuthorized
                }
            })
        },
        formatDate(date) {
            return this.$moment(date).format('DD-MM-YYYY')
        },
        shareForm(event, idChildForm) {
            let checked = 0
            if (event.target.checked === true) {
                checked = 1
            }
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            this.$request.post( '/ChildTrackingSystem/shareForm', {
                idChildForm: idChildForm,
                checked: checked,
                shareColumn: event.target.name
            }).then((response) => {
                this.$store.commit('REMOVE_ACTIVE_REQUEST')
                if (!response) {
                    alert("Er is een fout opgetreden tijdens uploaden")
                }
            })
        },
        shareDocument(event, idDocument) {
            let checked = 0
            if (event.target.checked === true) {
                checked = 1
            }
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            this.$request.post( '/ChildTrackingSystem/shareDocument', {
                idDocument: idDocument,
                checked: checked
            }).then((response) => {
                this.$store.commit('REMOVE_ACTIVE_REQUEST')
                if (!response) {
                    alert("Er is een fout opgetreden tijdens uploaden")
                }
            })
        },
        viewContent(childId, listId, idResult, formId) {
            this.isContent = true
            this.resultId = idResult
            this.childId = childId
            this.listId = listId
            this.formId = formId
        },
        uploadSave () {
            let files = this.$refs.file.files
            for (let i = 0; i < files.length; i++) {
                let formData = new FormData();
                formData.append('file', files[i])
                formData.append('idChild', this.id )
                this.$store.commit('REGISTER_ACTIVE_REQUEST')
                this.$request.post('/ChildTrackingSystem/uploadDocument', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then((response) => {
                    this.$store.commit('REMOVE_ACTIVE_REQUEST')
                    if (!response.uploaded) {
                        alert(response.errorMessage)
                    } else {
                        window.location.reload()
                    }
                })
            }
        },
        downloadDocument(id) {
            this.isLoading = true
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            this.$request.post( '/ChildTrackingSystem/downloadDocument', {
                idDocument: id
            }).then((response) => {
                this.$store.commit('REMOVE_ACTIVE_REQUEST')
                if (!response) {
                    alert("Er is een fout opgetreden tijdens het downloaden")
                    this.isLoading = false
                } else {
                    this.download(response.filename, response.fileContent)
                }
            })
        },
        download(filename, fileContent) {
            downloadBase64File(filename, fileContent)
            this.isLoading = false
        },
        deleteDocument (idDoc, filename) {
            if (confirm("Weet je het zeker dat je '" + filename + "' wilt verwijderen? Als het document gedeeld is met verzorgers, is het document ook voor verzorgers niet meer zichtbaar.")) {
                this.$store.commit('REGISTER_ACTIVE_REQUEST')
                this.$request.post('/ChildTrackingSystem/deleteDocument', {
                    idDoc: idDoc
                }).then((response) => {
                    this.$store.commit('REMOVE_ACTIVE_REQUEST')
                    if (!response) {
                        alert("Er is een fout opgetreden tijdens verwijderen")
                    } else {
                        this.getChildTrackingSystem()
                    }
                })
            }
        },
        printChildForm(idChildForm, idResult) {
            this.isLoading = true
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            this.$request.post('/ChildTrackingSystem/downloadChildForm', {
                idChildForm: idChildForm,
                idResult: idResult,
                answerOption: 'last'
            }).then((response) => {
                this.$store.commit('REMOVE_ACTIVE_REQUEST')
                if (response) {
                    this.download(response.filename, response.fileContent)
                } else {
                    this.isLoading = false
                }
            })
        },
        makeForm() {
            if (this.selectedForm > 0) {
                this.$router.push('/childtrackingsystem/generalForm/' + this.selectedChild.id + '/' + this.selectedForm + '/0')
            } else {
                alert('Kies een formulier om verder te kunnen gaan!')
            }
        },
        printForm (idChild, idForm, idGeneralForm) {
            this.isLoading = true
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            // eslint-disable-next-line no-undef
            this.$request.post('/ChildTrackingSystem/downloadGeneralForm', {
                idChild: idChild,
                idForm: idForm,
                idGeneralForm: idGeneralForm
            }).then((response) => {
                this.$store.commit('REMOVE_ACTIVE_REQUEST')
                if (response) {
                    this.download(response.filename, response.fileContent)
                } else {
                    this.isLoading = false
                }
            })
        },
    }
}
</script>

<style scoped>
.table-border-first {
    border-bottom: 2px solid #c3cad4;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-left: 0;
    margin-right: 0;
    color: #c3cad4;
}
.table-row {
    padding-top: 10px;
    margin-left: 0;
    margin-right: 0;
    border-bottom: 1px solid #c3cad4;
}
</style>